import { ProductBuilderMachineContext } from '../types';

export const getCurtainTrack = (
  option: string,
  pleatType: string,
  fitting: string,
  context: ProductBuilderMachineContext,
) => {
  const {
    ceilingMountPleatedCurtainRail,
    faceMountPleatedCurtainRail,
    ceilingMountWaveFoldCurtainRail,
    faceMountWaveFoldCurtainRail,
    ceilingMountPleatedCurtainDoubleRail,
    faceMountPleatedCurtainDoubleRail,
    ceilingMountWaveFoldCurtainDoubleRail,
    faceMountWaveFoldCurtainDoubleRail,
    custom: { measurements },
  } = context;

  const width = measurements.split('x')[0];
  let trackPrice = 0,
    curtainTrackVariantId = 0;

  // Helper function to find correct variant based on width
  const findCorrectVariant = (variants: any[], width: number) => {
    const matchingVariant = variants.find(variant => {
      const trackWidth = parseInt(variant.title.replace('mm', '').replace('m', ''));
      return trackWidth >= width; // Find first variant that covers the width
    });
    return matchingVariant || variants[variants.length - 1]; // Fallback to largest if no match
  };

  if (
    pleatType.includes('Wave Pleat') &&
    fitting === 'Ceiling Mount' &&
    option === 'Single Track'
  ) {
    const selectedVariant = findCorrectVariant(ceilingMountWaveFoldCurtainRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  } else if (
    (pleatType.includes('Single Pleat') ||
      pleatType.includes('Double Pleat')) &&
    fitting === 'Ceiling Mount' &&
    option === 'Single Track'
  ) {
    const selectedVariant = findCorrectVariant(ceilingMountPleatedCurtainRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  } else if (
    pleatType.includes('Wave Pleat') &&
    fitting === 'Face Mount' &&
    option === 'Single Track'
  ) {
    const selectedVariant = findCorrectVariant(
    faceMountWaveFoldCurtainRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  } else if (
    (pleatType.includes('Single Pleat') ||
      pleatType.includes('Double Pleat')) &&
    fitting === 'Face Mount' &&
    option === 'Single Track'
  ) {
    const selectedVariant = findCorrectVariant(
    faceMountPleatedCurtainRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  } else if (
    pleatType.includes('Wave Pleat') &&
    fitting === 'Ceiling Mount' &&
    option === 'Double Track'
  ) {
    const selectedVariant = findCorrectVariant(
    ceilingMountWaveFoldCurtainDoubleRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  } else if (
    (pleatType.includes('Single Pleat') ||
      pleatType.includes('Double Pleat')) &&
    fitting === 'Ceiling Mount' &&
    option === 'Double Track'
  ) {
    const selectedVariant = findCorrectVariant(
    ceilingMountPleatedCurtainDoubleRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  } else if (
    pleatType.includes('Wave Pleat') &&
    fitting === 'Face Mount' &&
    option === 'Double Track'
  ) {
    const selectedVariant = findCorrectVariant(
    faceMountWaveFoldCurtainDoubleRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  } else if (
    (pleatType.includes('Single Pleat') ||
      pleatType.includes('Double Pleat')) &&
    fitting === 'Face Mount' &&
    option === 'Double Track'
  ) {
    const selectedVariant = findCorrectVariant(
    faceMountPleatedCurtainDoubleRail[0].variants, parseInt(width, 10));
    curtainTrackVariantId = selectedVariant.id;
    trackPrice = selectedVariant.price;
  }

  return {
    price: trackPrice,
    id: curtainTrackVariantId,
  };
};